import React, { useEffect, useState } from 'react';
import { Modal, Button, ButtonGroup } from 'react-bootstrap';

const GENERIC_HELP_PDFS = [
  { name: 'Vowel sandhi', pdf: 'appendixD2.1-VowelSandhi.pdf' },
  { name: 'Final stop sandhi', pdf: 'appendixD2.2.1-FinalStopSandhi.pdf' },
  { name: 'Final nasal sandhi', pdf: 'appendixD2.2.2-FinalNasalSandhi.pdf' },
  { name: 'Visarga sandhi', pdf: 'appendixD2.2.3-VisargaSandhi.pdf' },
];

/**
 * Help PDF modal.
 * - If a specific pdf is provided, show that PDF directly.
 * - If no pdf is provided (generic help from highlighted error), show
 *   a 4-button selector and let user switch between the core sandhi PDFs.
 */
function HelpPDFsModal({ show, onHide, pdf }) {
  const [selectedPdf, setSelectedPdf] = useState(pdf || GENERIC_HELP_PDFS[0].pdf);

  useEffect(() => {
    if (!show) return;
    if (pdf) {
      setSelectedPdf(pdf);
    } else {
      setSelectedPdf(GENERIC_HELP_PDFS[0].pdf);
    }
  }, [show, pdf]);

  const isGenericMode = !pdf;
  const pdfUrl = selectedPdf ? `/docs/${selectedPdf}#zoom=100` : '';

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="pdfmodal-90w"
      centered
      size="xl"
    >
      <Modal.Body>
        {isGenericMode && (
          <ButtonGroup aria-label="sandhi-help-pdfs" className="mb-3">
            {GENERIC_HELP_PDFS.map((item) => (
              <Button
                key={item.pdf}
                variant="outline-primary"
                active={selectedPdf === item.pdf}
                onClick={() => setSelectedPdf(item.pdf)}
              >
                {item.name}
              </Button>
            ))}
          </ButtonGroup>
        )}
        {pdfUrl ? (
          <embed
            title="Help PDF"
            src={pdfUrl}
            className="help-pdf-embed"
            type="application/pdf"
          />
        ) : (
          <p className="text-muted">No PDF selected.</p>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default HelpPDFsModal;
